import { Link } from "react-router-dom";
import { getHot } from "@/lib/catalog";

const collections = [
  {
    id: "collection-must-watch",
    name: "本季必追日韩剧单",
    subtitle: "口碑最高的 5 部连载剧集，一集入坑",
    tag: "热门专题",
    count: 5,
    items: getHot(24).filter((t) => t.type === "drama").slice(0, 5),
    image:
      "https://readdy.ai/api/search-image?query=Artistic%20moody%20collage%20of%20night%20city%20lights%20and%20glowing%20television%20screen%2C%20deep%20navy%20blue%20and%20warm%20orange%20light%20accents%2C%20cinematic%20editorial%20composition%2C%20soft%20grain%20texture&width=800&height=500&seq=jk-collection-01&orientation=landscape",
  },
  {
    id: "collection-mystery",
    name: "深夜悬疑放映室",
    subtitle: "推理、犯罪与惊悚，一口气看到天亮",
    tag: "编辑精选",
    count: 4,
    items: getHot(24).filter((t) => t.genre.includes("悬疑") || t.genre.includes("犯罪") || t.genre.includes("惊悚")).slice(0, 4),
    image:
      "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20detective%20figure%20under%20a%20single%20street%20lamp%20in%20heavy%20rain%2C%20deep%20navy%20blue%20noir%20atmosphere%20with%20orange%20light%20glow%2C%20cinematic%20dark%20thriller%20composition%2C%20moody%20editorial&width=800&height=500&seq=jk-collection-02&orientation=landscape",
  },
  {
    id: "collection-healing",
    name: "治愈系慢生活片单",
    subtitle: "美食、四季与温柔的人，适合安静地看",
    tag: "温柔推荐",
    count: 4,
    items: getHot(24).filter((t) => t.genre.includes("治愈") || t.genre.includes("美食") || t.genre.includes("生活") || t.genre.includes("爱情")).slice(0, 4),
    image:
      "https://readdy.ai/api/search-image?query=Warm%20inviting%20Japanese%20home%20interior%20at%20dusk%20with%20soft%20amber%20lamp%20glow%2C%20rain%20on%20the%20window%2C%20deep%20navy%20blue%20evening%20outside%2C%20cozy%20cinematic%20still%20life%2C%20gentle%20nostalgic%20atmosphere&width=800&height=500&seq=jk-collection-03&orientation=landscape",
  },
];

export default function FeaturedCollections() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
      {collections.map((collection) => (
        <article
          key={collection.id}
          className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 flex flex-col"
        >
          <div className="relative w-full h-[150px] md:h-[170px] overflow-hidden">
            <img
              src={collection.image}
              alt={collection.name}
              title={`${collection.name} 日韩影视推荐专题`}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 to-transparent" />
            <span className="absolute left-4 top-4 px-2 py-0.5 rounded-md bg-background-50/90 text-[11px] font-label font-semibold text-foreground-900">
              {collection.tag}
            </span>
            <div className="absolute bottom-3 left-4 right-4">
              <h3 className="font-heading text-base md:text-lg font-black text-background-50">{collection.name}</h3>
            </div>
          </div>

          <div className="p-4 md:p-5 flex-1 flex flex-col">
            <p className="text-xs md:text-[13px] text-foreground-600 leading-relaxed">{collection.subtitle}</p>

            <ul className="mt-3 space-y-1.5 flex-1">
              {collection.items.map((item, i) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="flex items-center gap-2.5 py-1.5 rounded-md hover:bg-background-50 px-1.5 -mx-1.5 transition-colors group/row"
                  >
                    <span
                      className={`w-5 text-center font-label text-xs font-bold ${
                        i === 0 ? "text-accent-600" : "text-foreground-400"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 text-[13px] text-foreground-800 line-clamp-1 group-hover/row:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                    <span className="text-[11px] font-label text-foreground-400">{item.year}</span>
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between">
              <span className="text-[11px] font-label text-foreground-500">{collection.count} 部作品</span>
              <Link
                to={collection.items[0] ? `/detail/${collection.items[0].id}` : "/category/drama"}
                className="inline-flex items-center gap-1 text-[12px] font-label font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap"
              >
                查看片单 <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
              </Link>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}